import { OnInit } from "@angular/core";
var DateComponent = /** @class */ (function () {
    function DateComponent() {
    }
    DateComponent.prototype.ngOnInit = function () { };
    return DateComponent;
}());
export { DateComponent };
